module.exports = __webpack_public_path__ + "img/errorIcon.9e3fe7d8.svg";